import { GmoPaymentUrlGenerationParams } from '@/types/api/payment';

const STORAGE_KEY = 'subscription_payment_affiliate_context';
const contextKey = (customerId: number, subscriptionId: number) =>
  `${STORAGE_KEY}:${customerId}:${subscriptionId}`;

type PaymentAffiliateContext = {
  m_customer_id: number;
  t_subscription_id: number;
  m_affiliate_id: number;
  // 復帰時の照合用メタデータ。申込 API では未切り替え時に送らない。
  original_m_affiliate_id: number;
};

type AffiliateStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export const persistSubscriptionPaymentAffiliate = (
  context: PaymentAffiliateContext,
  storage: AffiliateStorage = window.localStorage,
) => {
  storage.setItem(
    contextKey(context.m_customer_id, context.t_subscription_id),
    JSON.stringify(context),
  );
  // 旧単一キーは複数契約で衝突するため、復元せず破棄する。
  storage.removeItem(STORAGE_KEY);
};

export const clearSubscriptionPaymentAffiliate = (
  customerId: number,
  subscriptionId: number,
  storage: AffiliateStorage = window.localStorage,
) => storage.removeItem(contextKey(customerId, subscriptionId));

export const hasSubscriptionPaymentAffiliateContext = (
  customerId: number,
  subscriptionId: number,
  storage: AffiliateStorage = window.localStorage,
): boolean => {
  try {
    const raw = storage.getItem(contextKey(customerId, subscriptionId));
    if (!raw) return false;
    const saved = JSON.parse(raw) as PaymentAffiliateContext;
    return (
      saved.m_customer_id === customerId &&
      saved.t_subscription_id === subscriptionId &&
      Number.isInteger(saved.m_affiliate_id) &&
      saved.m_affiliate_id > 0 &&
      Number.isInteger(saved.original_m_affiliate_id) &&
      saved.original_m_affiliate_id > 0
    );
  } catch {
    return false;
  }
};

export const resolveSubscriptionPaymentAffiliateId = (
  customerId: number,
  subscriptionId: number | undefined,
  contractAffiliateId: number | null | undefined,
): number | null => {
  // 決済先は契約の保存値だけから決める。ブラウザ記録や現在の切替状態は
  // 別端末・再ログイン・GMO復帰時に失われたり変わったりする。
  if (
    customerId <= 0 ||
    !subscriptionId ||
    !Number.isInteger(contractAffiliateId) ||
    !contractAffiliateId ||
    contractAffiliateId <= 0
  )
    return null;
  return contractAffiliateId;
};

export const subscriptionGmoPaymentParams = (
  customerId: number,
  affiliateId: number,
  orderId: string,
  amount: number,
  memberId: string,
  completeUrl: string,
  cancelUrl: string,
  isNewCard: boolean,
): GmoPaymentUrlGenerationParams => ({
  m_affiliate_id: String(affiliateId),
  m_customer_id: String(customerId),
  config_id: '1',
  order_id: orderId,
  amount: String(amount),
  complete_url: completeUrl,
  cancel_url: cancelUrl,
  member_id: memberId,
  ...(isNewCard
    ? {
        regist_member_id: memberId,
        regist_member_force_flg: 1,
        card_input_hidden_flag: 0,
      }
    : {}),
});
